import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "vuetify/lib/locale/en";
import he from "vuetify/lib/locale/he";
import ar from "vuetify/lib/locale/ar";

Vue.use(VueI18n);

const messages = {
	en: {
		...require("@/locales/en.json"),
		$vuetify: en,
	},
	he: {
		...require("@/locales/he.json"),
		$vuetify: he,
	},
  ar: {
		...require("@/locales/ar.json"),
		$vuetify: ar,
	},
};

export default new VueI18n({
	locale: document.querySelector("html").getAttribute('lang') || navigator.language || "he",
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
	messages,
});
